import { defineComponent as _, ref as C, watch as R, getCurrentInstance as F, onMounted as Y, onUpdated as j, onBeforeUnmount as G, onBeforeUpdate as Q, openBlock as c, createElementBlock as k, Fragment as T, createCommentVNode as B, renderSlot as g, inject as d, computed as v, h as A, useSlots as V, useAttrs as H, normalizeProps as K, guardReactiveProps as q, unref as o, createBlock as m, resolveDynamicComponent as h, withCtx as f, toDisplayString as J, onUnmounted as L, toRaw as M, toRefs as x, provide as O, resolveComponent as W, renderList as b, onServerPrefetch as X } from "vue";
import { TYPE_CONTAINER_INLINE as Z, TYPE_CONTAINER_NO_MARKUP as ee, TYPE_CONTAINER_ORDERED_LIST as te, TYPE_CONTAINER_UNORDERED_LIST as ne, TYPE_CONTAINER_ITEM_UNDEFINED as w, isContainerItem as oe, isContainer as ae, isComponent as re, TYPE_MANAGE_CONTENT_BUTTON as se, TYPE_MANAGE_MENU_BUTTON as ue, initialize as D, destroy as ce } from "@bloomreach/spa-sdk";
const S = /* @__PURE__ */ _({
  __name: "BrMeta",
  props: {
    meta: {}
  },
  setup(l) {
    const e = C(l.meta);
    let r;
    const a = C(), n = C(), p = () => {
      var s, t;
      !((s = a.value) != null && s.nextSibling) || !n.value || (r = (t = e.value) == null ? void 0 : t.render(a.value.nextSibling, n.value));
    };
    return R(e, () => {
      var s, t;
      return (t = (s = F()) == null ? void 0 : s.proxy) == null ? void 0 : t.$forceUpdate();
    }, { deep: !1 }), Y(() => p()), j(() => p()), G(() => r == null ? void 0 : r()), Q(() => r == null ? void 0 : r()), (s, t) => (c(), k(T, null, [
      e.value && e.value.length > 0 ? (c(), k("span", {
        key: 0,
        style: { display: "none" },
        ref_key: "head",
        ref: a
      }, null, 512)) : B("", !0),
      g(s.$slots, "default"),
      e.value && e.value.length > 0 ? (c(), k("span", {
        key: 1,
        style: { display: "none" },
        ref_key: "tail",
        ref: n
      }, null, 512)) : B("", !0)
    ], 64));
  }
}), y = Symbol("page$"), E = Symbol("mapping$"), I = Symbol("component$");
function P(l, u) {
  const e = d(y), r = v(() => {
    var n;
    return (n = e == null ? void 0 : e.value) == null ? void 0 : n.isPreview();
  }), a = () => {
    var i;
    const s = V().default()[0].children, t = (i = s == null ? void 0 : s[0]) == null ? void 0 : i.children;
    return t == null ? void 0 : t.map((N) => A(
      u,
      { class: { "hst-container-item": r } },
      [N]
    ));
  };
  return () => A(
    l,
    { class: { "hst-container": r } },
    a()
  );
}
const le = _({
  setup() {
    return P("div", "div");
  }
}), pe = _({
  setup() {
    return P("div", "span");
  }
}), me = /* @__PURE__ */ _({
  __name: "BrContainerNoMarkup",
  setup(l) {
    const u = H();
    return (e, r) => g(e.$slots, "default", K(q(o(u))));
  }
}), ie = _({
  setup() {
    return P("ol", "li");
  }
}), _e = _({
  setup() {
    return P("ul", "li");
  }
}), de = /* @__PURE__ */ _({
  __name: "BrNodeContainer",
  setup(l) {
    const u = d(y), e = d(I), r = d(E), a = v(() => {
      var n;
      return (n = e == null ? void 0 : e.value) == null ? void 0 : n.getType();
    });
    return (n, p) => a.value && a.value in o(r) ? (c(), m(h(o(r)[a.value]), {
      key: 0,
      component: o(e),
      page: o(u)
    }, {
      default: f(() => [
        g(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["component", "page"])) : a.value === o(Z) ? (c(), m(pe, {
      key: 1,
      component: o(e),
      page: o(u)
    }, {
      default: f(() => [
        g(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["component", "page"])) : a.value === o(ee) ? (c(), m(me, {
      key: 2,
      component: o(e),
      page: o(u)
    }, {
      default: f(() => [
        g(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["component", "page"])) : a.value === o(te) ? (c(), m(ie, {
      key: 3,
      component: o(e),
      page: o(u)
    }, {
      default: f(() => [
        g(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["component", "page"])) : a.value === o(ne) ? (c(), m(_e, {
      key: 4,
      component: o(e),
      page: o(u)
    }, {
      default: f(() => [
        g(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["component", "page"])) : (c(), m(le, {
      key: 5,
      component: o(e),
      page: o(u)
    }, {
      default: f(() => [
        g(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["component", "page"]));
  }
}), ge = /* @__PURE__ */ _({
  __name: "BrContainerItemUndefined",
  props: {
    component: {}
  },
  setup(l) {
    const u = l, e = v(() => u.component.getType());
    return (r, a) => (c(), k("div", null, J(`Component "${e.value}" is not defined.`), 1));
  }
}), ve = /* @__PURE__ */ _({
  __name: "BrNodeContainerItem",
  setup(l) {
    const u = d(y), e = d(E), r = d(I), a = v(() => r.value.getType());
    let n;
    function p(i) {
      const N = Object.create(Object.getPrototypeOf(i));
      return Object.assign(N, i);
    }
    const s = C(r.value), t = () => {
      s.value = p(r.value);
      const i = M(u.value);
      i == null || i.sync();
    };
    return L(() => n == null ? void 0 : n()), R(
      r,
      () => {
        n == null || n(), n = r.value.on("update", t);
      },
      { immediate: !0, deep: !0 }
    ), (i, N) => a.value && a.value in o(e) ? (c(), m(h(o(e)[a.value]), {
      key: 0,
      component: s.value,
      page: o(u)
    }, null, 8, ["component", "page"])) : o(w) in o(e) ? (c(), m(h(o(e)[o(w)]), {
      key: 1,
      component: s.value,
      page: o(u)
    }, null, 8, ["component", "page"])) : s.value ? (c(), m(ge, {
      key: 2,
      component: s.value
    }, null, 8, ["component"])) : B("", !0);
  }
}), z = /* @__PURE__ */ _({
  __name: "BrNodeComponent",
  props: {
    component: {}
  },
  setup(l) {
    const u = l, { component: e } = x(u), r = d(y), a = d(E), n = v(() => {
      var t;
      return (t = e == null ? void 0 : e.value) == null ? void 0 : t.getChildren();
    }), p = v(() => {
      var t;
      return (t = e == null ? void 0 : e.value) == null ? void 0 : t.getMeta();
    }), s = v(() => {
      var t;
      return (t = e == null ? void 0 : e.value) == null ? void 0 : t.getName();
    });
    return O(I, e), (t, i) => {
      var U;
      const N = W("br-node-component", !0);
      return c(), m(S, {
        meta: p.value,
        key: (U = o(e)) == null ? void 0 : U.getId()
      }, {
        default: f(() => [
          g(t.$slots, "default", {}, () => [
            o(oe)(o(e)) ? (c(), m(ve, { key: 0 })) : o(ae)(o(e)) ? (c(), m(de, { key: 1 }, {
              default: f(() => [
                (c(!0), k(T, null, b(n.value, ($) => (c(), m(N, {
                  key: $.getId(),
                  component: $
                }, null, 8, ["component"]))), 128))
              ]),
              _: 1
            })) : s.value && s.value in o(a) ? (c(), m(h(o(a)[s.value]), {
              key: 2,
              component: o(e),
              page: o(r)
            }, null, 8, ["component", "page"])) : (c(!0), k(T, { key: 3 }, b(n.value, ($) => (c(), m(N, {
              key: $.getId(),
              component: $
            }, null, 8, ["component"]))), 128))
          ])
        ]),
        _: 3
      }, 8, ["meta"]);
    };
  }
}), fe = /* @__PURE__ */ _({
  __name: "BrComponent",
  props: {
    component: {}
  },
  setup(l) {
    const u = l;
    function e(p, s) {
      if (re(s))
        return [s];
      if (!p)
        return [];
      if (!s)
        return p.getChildren();
      const t = p.getComponent(...s.split("/"));
      return t ? [t] : [];
    }
    const r = d(y), a = d(I), n = v(() => e(a == null ? void 0 : a.value, u.component));
    return (p, s) => (c(!0), k(T, null, b(n.value, (t) => (c(), m(z, { component: t }, {
      default: f(() => [
        g(p.$slots, "default", {
          component: t,
          page: o(r)
        })
      ]),
      _: 2
    }, 1032, ["component"]))), 256));
  }
}), ye = /* @__PURE__ */ _({
  __name: "BrManageContentButton",
  props: {
    content: {},
    documentTemplateQuery: {},
    folderTemplateQuery: {},
    path: {},
    parameter: {},
    pickerConfiguration: {},
    pickerEnableUpload: { type: Boolean },
    pickerInitialPath: {},
    pickerRemembersLastVisited: { type: Boolean },
    pickerRootPath: {},
    pickerSelectableNodeTypes: {},
    relative: { type: Boolean },
    root: {}
  },
  setup(l) {
    const u = l, e = d(y), r = v(() => {
      var a;
      return (a = e == null ? void 0 : e.value) == null ? void 0 : a.getButton(se, u);
    });
    return (a, n) => {
      var p;
      return o(e) && ((p = o(e)) != null && p.isPreview()) ? (c(), m(S, {
        key: 0,
        meta: r.value
      }, null, 8, ["meta"])) : B("", !0);
    };
  }
}), Ne = /* @__PURE__ */ _({
  __name: "BrManageMenuButton",
  props: {
    menu: {}
  },
  setup(l) {
    const u = l, e = d(y), r = v(() => {
      var a;
      return (a = e == null ? void 0 : e.value) == null ? void 0 : a.getButton(ue, u.menu);
    });
    return (a, n) => o(e) && o(e).isPreview() ? (c(), m(S, {
      key: 0,
      meta: r.value
    }, null, 8, ["meta"])) : B("", !0);
  }
}), ke = /* @__PURE__ */ _({
  __name: "BrPage",
  props: {
    page: {},
    configuration: {},
    mapping: {}
  },
  setup(l) {
    const u = l;
    function e() {
      n.value && ce(n.value);
    }
    const { configuration: r, mapping: a } = x(u), n = C(), p = v(() => {
      var t;
      return (t = n.value) == null ? void 0 : t.getComponent();
    });
    let s = null;
    return O(y, n), O(E, a), R(r, async (t, i) => {
      if (!i && u.page) {
        n.value = D(t, u.page);
        return;
      }
      e(), s = D(t), n.value = await s, s = null;
    }, { deep: !0, immediate: !0 }), Y(() => {
      const t = M(n.value);
      t == null || t.sync();
    }), j(() => {
      const t = M(n.value);
      t == null || t.sync();
    }), L(() => e()), X(async () => await s), (t, i) => n.value || o(r).NBRMode ? (c(), m(z, {
      key: 0,
      component: p.value
    }, {
      default: f(() => [
        g(t.$slots, "default", {
          component: p.value,
          page: n.value
        })
      ]),
      _: 3
    }, 8, ["component"])) : B("", !0);
  }
}), Ce = {
  install(l) {
    l.component("br-component", fe), l.component("br-manage-content-button", ye), l.component("br-manage-menu-button", Ne), l.component("br-page", ke);
  }
};
export {
  fe as BrComponent,
  ye as BrManageContentButton,
  Ne as BrManageMenuButton,
  ke as BrPage,
  Ce as BrSdk
};
//# sourceMappingURL=index.js.map
